import { render, staticRenderFns } from "./UsersEditor.vue?vue&type=template&id=35e8e09e&scoped=true&"
import script from "./UsersEditor.vue?vue&type=script&lang=js&"
export * from "./UsersEditor.vue?vue&type=script&lang=js&"
import style0 from "./UsersEditor.vue?vue&type=style&index=0&id=35e8e09e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8e09e",
  null
  
)

export default component.exports